import React from 'react';
import { Link } from 'react-router-dom';
import { Phone } from 'lucide-react';
export function HomeFinalCTA() {
  return <section className="relative py-24 overflow-hidden bg-ink" data-id="element-1664">
      <div className="absolute top-0 right-0 w-1/2 h-full bg-charcoal transform skew-x-12 translate-x-20 opacity-50 pointer-events-none" data-id="element-1665" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-1666">
        <h2 className="text-4xl md:text-5xl text-white mb-6" data-id="element-1667">
          Ready to Find the Right Storm Program?
        </h2>
        <p className="text-xl text-gray-warm mb-10 max-w-2xl mx-auto" data-id="element-1668">
          Whether you're looking for kids taekwondo, adult martial arts, family
          classes, self-defense, competition training, or summer camp, Storm
          Taekwondo can help you get started.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1669">
          <Link to="/ContactUs.html" className="btn-primary w-full sm:w-auto" data-id="element-1670">
            Check Availability
          </Link>
          <a href="tel:517-220-0621" className="btn-outline border-gray-warm text-white hover:bg-white hover:text-ink w-full sm:w-auto gap-2" data-id="element-1671">
            <Phone className="w-5 h-5" data-id="element-1672" />
            Call 517-220-0621
          </a>
        </div>
        <p className="text-sm text-gray-warm mt-8" data-id="element-1673">
          Ages 3+ • Beginners welcome • Farmington Hills, Michigan
        </p>
      </div>
    </section>;
}